export type Submission = {
  id: string;
  createdAt: string;
  empresa: string;
  nomeResponsavel: string;
  cargoResponsavel: string;
  email: string;
  whatsapp: string;
  faturamento: string;
  momento: string;
  carga: string;
  setor: string;
  regime: string;
  margem: string;
  custos: string;
  maoDeObra: string;
  perfilClientes: string;
};

export const MOMENTOS = [
  "Já avaliamos os impactos da Reforma Tributária",
  "Sabemos das mudanças, mas ainda sem plano definido",
  "Ainda não paramos para analisar",
] as const;

export const CARGAS = ["0% - 10%", "11% - 15%", "16% - 20%", "21% - 30%", "31% - 40%", "41% - 50%", "Acima de 50%"] as const;

export const SETORES = [
  "Publicidade", "Tecnologia da Informação", "Eventos", "Educação", "Comércio", "Indústria", "Imobiliário",
  "Bar/Restaurante", "Saúde", "Serviços Financeiros", "Corretora", "Turismo", "Hotelaria",
  "Serviços Regulamentados", "Consultoria", "Construção Civil", "Transporte", "Agronegócio", "Combustíveis",
] as const;

export const REGIMES = ["Simples Nacional", "Lucro Presumido", "Lucro Real"] as const;

export const MARGENS = ["Prejuízo / Zero", "Até 5%", "6% - 10%", "11% - 15%", "16% - 20%", "21% - 30%", "Acima de 30%"] as const;

export const CUSTOS = [
  "Revenda de mercadorias",
  "Matérias-primas",
  "Serviços PJ",
  "Salários / CLT / Pró-labore",
  "Estrutura / Aluguel / Energia",
  "Distribuído de forma equilibrada",
] as const;

export const MAO_DE_OBRA = [
  "Predominantemente CLT",
  "Predominantemente prestadores PJ",
  "Combinação CLT + PJ",
  "Avulsos / Temporários",
  "Pouca mão de obra",
] as const;

export const PERFIS = ["Majoritariamente B2B", "Majoritariamente B2C", "Misto"] as const;

export function formatPhone(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (!digits.length) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function formatCurrency(value: string) {
  const digits = value.replace(/\D/g, "");
  if (!digits) return "";
  const number = Number(digits) / 100;
  return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
}
